export const common = {
  nav: {
    home: 'Главная',
    ourPuppies: 'Наши щенки',
    accessories: 'Аксессуары',
    boarding: 'Передержка щенков',
    aboutUs: 'О нас',
    contactUs: 'Контакты'
  },
  hero: {
    title: 'Найдите своего идеального',
    titleHighlight: 'пушистого друга',
    subtitle: 'Премиальные пудели и мальтипу, выращенные с любовью и заботой. Здоровые, счастливые щенки готовы присоединиться к вашей семье.',
    viewPuppies: 'Посмотреть доступных щенков',
    contact: 'Связаться с нами',
    yearsExperience: 'Лет опыта',
    happyFamilies: 'Счастливых семей'
  },
  puppies: {
    title: 'Доступные',
    titleHighlight: 'щенки',
    subtitle: 'Познакомьтесь с нашими очаровательными щенками, которые ищут свой вечный дом. Каждый из них проверен на здоровье, вакцинирован и готов принести радость вашей семье.',
    allPuppies: 'Все щенки',
    poodles: 'Пудели',
    maltipoos: 'Мальтипу',
    available: 'Доступен',
    notAvailable: 'Не доступен',
    inquireNow: 'Узнать подробнее',
    age: 'возраст',
    male: 'Мальчик',
    female: 'Девочка'
  },
  about: {
    title: 'О',
    titleHighlight: 'Dog Store',
    intro: 'Добро пожаловать в Dog Store, где мы занимаемся разведением премиальных пуделей и мальтипу уже более десяти лет. Наша страсть - выращивание здоровых, счастливых щенков в любящей домашней обстановке.',
    paragraph1: 'Каждый щенок выращивается с исключительной заботой, правильной социализацией и проходит комплексные медицинские обследования. Мы верим в ответственное разведение и стремимся подобрать каждому щенку идеальную семью.',
    paragraph2: 'Наши пудели и мальтипу известны своим интеллектом, ласковым характером и гипоаллергенной шерстью, что делает их идеальными компаньонами для семей, пожилых людей и отдельных лиц.',
    healthGuarantee: 'Гарантия здоровья',
    healthGuaranteeDesc: 'Все щенки поставляются с полными медицинскими сертификатами и гарантиями',
    lifetimeSupport: 'Пожизненная поддержка',
    lifetimeSupportDesc: 'Мы здесь для вас и вашего щенка на протяжении всей его жизни'
  },
  whyChoose: {
    title: 'Почему выбирают',
    titleHighlight: 'Dog Store',
    subtitle: 'Мы стремимся к совершенству в разведении и предоставляем семьям здоровых, счастливых щенков. Вот что отличает нас от других заводчиков.',
    healthCertified: 'Сертифицированное здоровье',
    healthCertifiedDesc: 'Все наши щенки проходят комплексные ветеринарные осмотры и вакцинацию по возрасту.',
    championBloodlines: 'Чемпионские линии',
    championBloodlinesDesc: 'Наши племенные собаки происходят от чемпионских линий с отличным темпераментом и историей здоровья.',
    homeRaised: 'Выращены дома',
    homeRaisedDesc: 'Щенки выращиваются в нашем доме с ежедневной социализацией, что обеспечивает хорошо адаптированных и дружелюбных компаньонов.',
    completeDocumentation: 'Полная документация',
    completeDocumentationDesc: 'Регистрационные документы, медицинские записи, история вакцинации и инструкции по уходу включены для каждого щенка.',
    ongoingSupport: 'Постоянная поддержка',
    ongoingSupportDesc: 'Мы предоставляем пожизненную поддержку заводчика и всегда готовы ответить на вопросы о вашем щенке.',
    puppyStarterKit: 'Стартовый набор для щенка',
    puppyStarterKitDesc: 'Каждый щенок уезжает домой с кормом, игрушками, одеялом с запахом однопометников и необходимыми принадлежностями для облегчения адаптации.',
    ctaTitle: 'Готовы приветствовать нового члена семьи?',
    ctaSubtitle: 'Наши щенки пользуются большим спросом. Зарезервируйте своего идеального компаньона сегодня!',
    ctaButton: 'Связаться'
  },
  testimonials: {
    title: 'Счастливые',
    titleHighlight: 'семьи',
    subtitle: 'Не верьте нам на слово. Вот что говорят наши довольные клиенты о своем опыте с PawfectPups и их новыми пушистыми членами семьи.'
  },
  contact: {
    title: 'Свяжитесь',
    titleHighlight: 'с нами',
    subtitle: 'Заинтересованы в одном из наших очаровательных щенков? Есть вопросы о нашей программе разведения? Мы будем рады услышать от вас! Заполните форму, и мы свяжемся с вами в течение 24 часов.',
    phone: 'Телефон',
    phoneSchedule: 'Пн-Сб: 9:00 - 18:00',
    email: 'Электронная почта',
    emailResponse: 'Мы отвечаем в течение 24 часов',
    location: 'Местоположение',
    locationCity: 'Москва, Россия',
    fullName: 'Полное имя',
    emailAddress: 'Адрес электронной почты',
    phoneNumber: 'Номер телефона',
    interestedIn: 'Интересует',
    selectBreed: 'Выберите породу',
    toyPoodle: 'Той-пудель',
    miniaturePoodle: 'Миниатюрный пудель',
    maltipoo: 'Мальтипу',
    notSure: 'Еще не уверен',
    message: 'Сообщение',
    messagePlaceholder: 'Расскажите о себе и о том, какого щенка вы ищете...',
    charactersLimit: 'символов',
    sendMessage: 'Отправить сообщение',
    sending: 'Отправка...',
    successMessage: 'Спасибо! Мы свяжемся с вами в течение 24 часов.',
    errorMessage: 'Что-то пошло не так. Пожалуйста, попробуйте еще раз.'
  },
  footer: {
    description: 'Премиальные пудели и мальтипу, выращенные с любовью и заботой. Ваш надежный источник здоровых, счастливых щенков.',
    quickLinks: 'Быстрые ссылки',
    home: 'Главная',
    availablePuppies: 'Доступные щенки',
    aboutUs: 'О нас',
    contact: 'Контакты',
    ourBreeds: 'Наши породы',
    toyPoodles: 'Той-пудели',
    miniaturePoodles: 'Миниатюрные пудели',
    maltipoos: 'Мальтипу',
    championBloodlines: 'Чемпионские линии',
    healthCertified: 'Сертифицированное здоровье',
    contactInfo: 'Контактная информация',
    schedule: 'Пн-Сб: 9:00 - 18:00',
    locationCity: 'Москва, Россия',
    copyright: '© 2024 Dog Store. Все права защищены.',
    privacyPolicy: 'Политика конфиденциальности',
    termsOfService: 'Условия использования',
    websiteBuilder: 'Конструктор сайтов'
  },
  accessories: {
    title: 'Роскошные',
    titleHighlight: 'Аксессуары',
    subtitle: 'Побалуйте своего драгоценного питомца нашей эксклюзивной коллекцией гламурных аксессуаров',
    comingSoon: 'Скоро будет в наличии',
    comingSoonDescription: 'Мы готовим эксклюзивную коллекцию роскошных аксессуаров для ваших любимых щенков. Следите за обновлениями!',
    categories: {
      collars: 'Ошейники',
      beds: 'Лежанки',
      bowls: 'Миски',
      carriers: 'Переноски',
      clothing: 'Одежда',
      grooming: 'Уход',
      toys: 'Игрушки',
      leashes: 'Поводки',
    },
    items: {
      luxuryCollar: {
        name: 'Ошейник с кристаллами',
        description: 'Ручная работа с кристаллами Swarovski и премиум бархатом',
      },
      plushBed: {
        name: 'Королевская бархатная лежанка',
        description: 'Ультра-мягкий бархат с золотой отделкой',
      },
      crystalBowl: {
        name: 'Золотой набор для кормления',
        description: 'Керамические миски с акцентами из 24-каратного золота',
      },
      designerCarrier: {
        name: 'Роскошная переноска',
        description: 'Дизайнерская переноска с плюшевым интерьером',
      },
      silkBandana: {
        name: 'Коллекция шелковых бандан',
        description: 'Премиум шелк с элегантными узорами',
      },
      groomingKit: {
        name: 'Спа-набор для ухода',
        description: 'Профессиональные инструменты в роскошном кейсе',
      },
      toySet: {
        name: 'Коллекция плюшевых игрушек',
        description: 'Игрушки ручной работы из безопасных материалов',
      },
      leatherLeash: {
        name: 'Премиум кожаный поводок',
        description: 'Итальянская кожа с золотой фурнитурой',
      },
    },
    addToCart: 'В корзину',
    specialOffer: {
      title: 'Специальное предложение',
      description: 'Получите скидку 20% при покупке аксессуаров вместе с щенком!',
      button: 'Купить наборы',
    },
    notifyMe: {
      title: 'Получить уведомление',
      description: 'Будьте первыми, кто узнает о запуске нашей коллекции роскошных аксессуаров!',
      button: 'Уведомить меня',
    },
  },
  boarding: {
    title: 'Передержка',
    titleHighlight: 'щенков',
    subtitle: 'Уезжаете в отпуск? Мы предоставляем премиальные услуги передержки для ваших любимых щенков с круглосуточным уходом, комфортными условиями и ежедневными обновлениями.',
    formTitle: 'Забронировать проживание щенка',
    ownerName: 'Ваше имя',
    email: 'Электронная почта',
    phone: 'Телефон',
    puppyName: 'Кличка щенка',
    breed: 'Порода',
    selectBreed: 'Выберите породу',
    poodle: 'Пудель',
    maltipoo: 'Мальтипу',
    other: 'Другая',
    checkInDate: 'Дата заезда',
    checkOutDate: 'Дата выезда',
    specialRequirements: 'Особые требования',
    specialRequirementsPlaceholder: 'Особые диетические потребности, лекарства или инструкции по уходу...',
    submitBooking: 'Отправить бронирование',
    submitting: 'Отправка...',
    successMessage: 'Спасибо! Ваш запрос на бронирование получен. Мы свяжемся с вами в течение 24 часов для подтверждения.',
    errorMessage: 'Что-то пошло не так. Пожалуйста, проверьте все обязательные поля и попробуйте снова.',
    feature1Title: 'Роскошные условия',
    feature1Desc: 'Просторные комнаты с климат-контролем, удобными лежанками и игрушками',
    feature2Title: 'Профессиональный уход 24/7',
    feature2Desc: 'Опытный персонал обеспечивает круглосуточное внимание и заботу',
    feature3Title: 'Ежедневные фото-отчеты',
    feature3Desc: 'Получайте фотографии и новости о вашем щенке каждый день во время пребывания'
  }
};
